var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLamp = function SvgLamp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#lamp_svg__a)"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    width: 32.856,
    height: 32.856,
    x: 11.572,
    y: 34.179
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.3px)",
      clipPath: "url(#lamp_svg__b)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.607,
    filter: "url(#lamp_svg__c)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lamp_svg__d)",
    d: "M22 42.462c0-.255.207-.462.462-.462h11.077c.254 0 .461.207.461.462V48a6 6 0 0 1-12 0z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#lamp_svg__e)",
    strokeOpacity: 0.5,
    d: "M33.5 42.5V48a5.5 5.5 0 1 1-11 0v-5.5z",
    style: {
      mixBlendMode: "soft-light"
    }
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 55.188,
    height: 58.188,
    x: 0.406,
    y: -4.945
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.32px)",
      clipPath: "url(#lamp_svg__f)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.648,
    filter: "url(#lamp_svg__g)",
    shapeRendering: "crispEdges"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lamp_svg__h)",
    fillOpacity: 0.2,
    d: "M28 3c9.389 0 17 7.611 17 17a16.94 16.94 0 0 1-4.948 11.987C38.852 33.193 38 34.753 38 36.453A3.547 3.547 0 0 1 34.453 40H21.547A3.547 3.547 0 0 1 18 36.453c0-1.7-.853-3.26-2.052-4.466A16.94 16.94 0 0 1 11 20c0-9.389 7.611-17 17-17"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lamp_svg__i)",
    d: "M28 3c9.389 0 17 7.611 17 17a16.94 16.94 0 0 1-4.948 11.987C38.852 33.193 38 34.753 38 36.453A3.547 3.547 0 0 1 34.453 40H21.547A3.547 3.547 0 0 1 18 36.453c0-1.7-.853-3.26-2.052-4.466A16.94 16.94 0 0 1 11 20c0-9.389 7.611-17 17-17",
    style: {
      mixBlendMode: "screen"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.5,
    d: "M28 3.5c9.113 0 16.5 7.387 16.5 16.5 0 4.54-1.834 8.651-4.803 11.635-1.26 1.267-2.197 2.947-2.197 4.818a3.047 3.047 0 0 1-3.047 3.047H21.547a3.047 3.047 0 0 1-3.047-3.047c0-1.871-.936-3.55-2.197-4.818A16.44 16.44 0 0 1 11.5 20l.006-.426C11.728 10.8 18.8 3.728 27.574 3.506z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M31 34V23c0-.932 0-1.398-.152-1.765a2 2 0 0 0-1.083-1.083C29.398 20 28.932 20 28 20s-1.398 0-1.765.152a2 2 0 0 0-1.083 1.083C25 21.602 25 22.068 25 23v11m6-16a3 3 0 1 1 3 3h-2.882a.12.12 0 0 1-.118-.118zm-6 0a3 3 0 1 0-3 3h2.882a.12.12 0 0 0 .118-.118z"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    width: 40.856,
    height: 36.856,
    x: 7.572,
    y: 25.179
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.3px)",
      clipPath: "url(#lamp_svg__j)",
      height: "100%",
      width: "100%"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 2.607,
    filter: "url(#lamp_svg__k)",
    shapeRendering: "crispEdges"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lamp_svg__l)",
    fillOpacity: 0.5,
    d: "M18 39.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C21.04 33 22.16 33 24.4 33h7.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C38 36.04 38 37.16 38 39.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C34.96 49 33.84 49 31.6 49h-7.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C18 45.96 18 44.84 18 42.6z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#lamp_svg__m)",
    d: "M18 39.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C21.04 33 22.16 33 24.4 33h7.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C38 36.04 38 37.16 38 39.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C34.96 49 33.84 49 31.6 49h-7.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C18 45.96 18 44.84 18 42.6z",
    style: {
      mixBlendMode: "screen"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeOpacity: 0.25,
    d: "M24.4 33.5h7.2c1.128 0 1.945 0 2.587.053.636.052 1.056.153 1.402.329a3.5 3.5 0 0 1 1.53 1.53c.175.345.276.765.328 1.401.053.642.053 1.459.053 2.587v3.2c0 1.128 0 1.945-.053 2.587-.052.636-.153 1.056-.329 1.402a3.5 3.5 0 0 1-1.53 1.53c-.345.175-.765.276-1.401.328-.642.053-1.459.053-2.587.053h-7.2c-1.128 0-1.945 0-2.586-.053-.637-.052-1.057-.153-1.403-.329a3.5 3.5 0 0 1-1.53-1.53c-.175-.345-.276-.765-.328-1.401-.053-.642-.053-1.459-.053-2.587v-3.2c0-1.128 0-1.945.053-2.587.052-.636.153-1.056.329-1.402a3.5 3.5 0 0 1 1.53-1.53c.345-.175.765-.276 1.402-.328.641-.053 1.458-.053 2.586-.053Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "lamp_svg__d",
    x1: 28.375,
    x2: 28.375,
    y1: 42.176,
    y2: 62.074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8B61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D92E7F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lamp_svg__e",
    x1: 32.301,
    x2: 27.628,
    y1: 42,
    y2: 54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lamp_svg__h",
    x1: 28,
    x2: 28,
    y1: 19.419,
    y2: 40,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#F3F3F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lamp_svg__l",
    x1: 28,
    x2: 28,
    y1: 40.1,
    y2: 49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9A6F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.969,
    stopColor: "#E95971"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lamp_svg__b",
    transform: "translate(-11.572 -34.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 42.462c0-.255.207-.462.462-.462h11.077c.254 0 .461.207.461.462V48a6 6 0 0 1-12 0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lamp_svg__f",
    transform: "translate(-.406 4.945)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 3c9.389 0 17 7.611 17 17a16.94 16.94 0 0 1-4.948 11.987C38.852 33.193 38 34.753 38 36.453A3.547 3.547 0 0 1 34.453 40H21.547A3.547 3.547 0 0 1 18 36.453c0-1.7-.853-3.26-2.052-4.466A16.94 16.94 0 0 1 11 20c0-9.389 7.611-17 17-17"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lamp_svg__j",
    transform: "translate(-7.572 -25.179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 39.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C21.04 33 22.16 33 24.4 33h7.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C38 36.04 38 37.16 38 39.4v3.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C34.96 49 33.84 49 31.6 49h-7.2c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C18 45.96 18 44.84 18 42.6z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "lamp_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lamp_svg__c",
    width: 32.856,
    height: 32.856,
    x: 11.572,
    y: 34.179,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.607
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.214
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lamp_svg__g",
    width: 55.188,
    height: 58.188,
    x: 0.406,
    y: -4.945,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.648
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.297
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "lamp_svg__k",
    width: 40.856,
    height: 36.856,
    x: 7.572,
    y: 25.179,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.607
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.214
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.690196 0 0 0 0 0.698039 0 0 0 0 0.729412 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "multiply",
    result: "effect1_dropShadow_4772_6971"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4772_6971",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "lamp_svg__i",
    width: 1.882,
    height: 1.73,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lamp_svg__n",
    transform: "scale(.00184 .00169)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "lamp_svg__m",
    width: 3.15,
    height: 3.938,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lamp_svg__n",
    transform: "scale(.00308 .00385)"
  })))));
};
export default SvgLamp;